import { patchState, signalStoreFeature, type, withMethods } from "@ngrx/signals";
import { IProviderState, initialProviderState } from "./provider.state";
import { Provider } from "../../models/provider/provider.model";
import { ProviderProfile } from "../../models/provider/provider-profile.model";

export const withProviderStateMethods = signalStoreFeature(
    { state: type<IProviderState>() },
    withMethods((store) => ({
        setProvider: (provider: Provider | null) => {
            patchState(store, { provider, loading: false, saving: false, error: null });
        },
        setProviderProfile: (providerProfile: ProviderProfile | null) => {
            patchState(store, { providerProfile, loading: false, error: null });
        },
        setProviderGuid: (providerGuid: string | null) => {
            patchState(store, { providerGuid });
        },
        setError: (error: string) => {
            patchState(store, { error, loading: false, saving: false, deleting: false });
        },
        clearProvider: () => {
            patchState(store, initialProviderState);
        }
    }))
);
